<template>
    <div>
        <vs-table :data="information" stripe>

            <template slot="thead">
                <vs-th v-if="use_number">
                    №
                </vs-th>
                <vs-th v-for="(key, index) in keys" :key="index">
                    {{ $t(key) }}
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td v-if="use_number">
                        {{ indextr + 1 }}
                    </vs-td>
                    <vs-td  v-for="(key, index) in keys" :key="index">
                        {{ data[indextr][key] }}
                    </vs-td>
                </vs-tr>
            </template>

        </vs-table>
    </div>
</template>

<script>
export default {
    name: "TableView",
    props:{
        information:{
            type:Array,
        },
        use_number:{
            type:Boolean,
            default:true,
        }
    },
    data(){
        return {
        }
    },
    computed:{
        keys() {
            if (this.information.length > 0) {
                return Object.keys(this.information[0]);
            }
            return [];
        }
    }
};
</script>

<style scoped>

</style>
